<template>
    <div class="container-fluid">
        <NavBar></NavBar>

        <router-view></router-view>
    </div>
</template>

<script>
import NavBar from './web-service-antrean/NavBar.vue'

export default {
    components: {
        NavBar
    },
    data() {
        return {
            //
        }
    },
    created() {
        //
    },
    methods: {
        //
    }
}
</script>
